// @flow

import React from 'react';

import { Hidden, Text, TextLink } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type MoreJobsLinksProps = {
  advertiser: EnrichedAdvertiser,
  small?: boolean
};

const MoreJobsLink = ({
  advertiser: { searchParams },
  small,
  ...restProps
}: MoreJobsLinksProps) => (
  <Hidden print component={Text} small={small}>
    <NavLink
      location={{
        pathname: '/jobs',
        query: { ...searchParams, companysearch: true }
      }}
      component={TextLink}
      {...restProps}
    >
      More jobs from this company
    </NavLink>
  </Hidden>
);

export default MoreJobsLink;
